import { WithdrawalTransactionsPage } from 'features/transactions';

export const TechOperatorWithdrawalTransactionsPage: React.FC = () => (
  <WithdrawalTransactionsPage />
);
